import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.ComponentProps<'input'> {
  error?: string | boolean;
  required?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, required, ...props }, ref) => {
    const isInvalid = Boolean(error) || (required && !props.value);
    const errorMessage = typeof error === 'string' ? error : '';
    const displayError =
      errorMessage || (isInvalid && required ? 'Required' : '');

    return (
      <div className="tw-relative">
        <input
          ref={ref}
          type={type}
          data-slot="input"
          className={cn(
            'tw-file:text-foreground tw-placeholder:text-muted-foreground tw-selection:bg-primary tw-selection:text-primary-foreground tw-dark:bg-input/30 tw-border-input tw-flex tw-h-9 tw-w-full tw-min-w-0 tw-rounded-md tw-border tw-bg-background tw-px-3 tw-py-1 tw-text-base tw-shadow-xs tw-transition-[color,box-shadow] tw-outline-none tw-file:inline-flex tw-file:h-7 tw-file:border-0 tw-file:bg-transparent tw-file:text-sm tw-file:font-medium tw-disabled:pointer-events-none tw-disabled:cursor-not-allowed tw-md:text-sm',
            'tw-focus-visible:border-ring tw-focus-visible:ring-ring/50 tw-focus-visible:ring-[3px]',
            'tw-aria-invalid:ring-destructive/20 tw-dark:aria-invalid:ring-destructive/40 tw-aria-invalid:border-destructive',
            isInvalid && '!tw-border-red-500 focus-visible:!tw-ring-red-500',
            className,
            props.disabled &&
              '!tw-bg-gray-50 !tw-opacity-50 tw-cursor-not-allowed',
          )}
          {...props}
        />
        {isInvalid && displayError && (
          <span className="tw-absolute tw-top-full tw-left-2 tw-text-xs tw-text-red-500 tw--mt-2 tw-px-1 tw-rounded-sm tw-bg-white">
            {displayError}
          </span>
        )}
      </div>
    );
  },
);

Input.displayName = 'Input';

export { Input };
